import React from 'react';

import classNames from 'classnames';

import s from './cartSkeleton.scss';

/**
 * CartSkeleton which showed before cart page loading
 */
export const CartSkeleton = () => {
    return (
        <div className={s.container}>
            <div className={classNames(s.baseBlock, s.title)} />
            <div className={classNames(s.baseBlock, s.titleQuantity)} />
            <div className={classNames(s.baseBlock, s.body)} />
            <div className={classNames(s.baseBlock, s.rightSideContent)} />
        </div>
    );
};
